import React from 'react';

export default props => (
  <svg viewBox={props.viewBox || '0 0 25 25'} style={{ display: 'block', margin: '0 auto' }}>
    <g fill={props.color}>
      <path d="M1.3,25v-1.1c0-6,5.3-11.4,11.2-11.4s11.1,5.4,11.1,11.3V25H1.3z M12.6,12.6c-3.5,0-6.3-2.8-6.3-6.3 S9.1,0,12.6,0s6.3,2.8,6.3,6.3C18.9,9.8,16.1,12.6,12.6,12.6z" />
    </g>
  </svg>
);
